import { grommet } from 'grommet'
import { deepMerge } from 'grommet/utils'
import { defaultProps } from 'grommet'

const hexToRGBA = (hexVal, opacity = 100) => {
  const hex = hexVal.replace('#', '')
  const r = parseInt(hex.substring(0, 2), 16)
  const g = parseInt(hex.substring(2, 4), 16)
  const b = parseInt(hex.substring(4, 6), 16)

  return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')'
}

export const brandColors = {
  'mesh-green-1': '#1B4A3B',
  'mesh-green-2': '#03783D',
  'mesh-green-3': '#AFD24A',
  'mesh-yellow-1': '#FFBE42',
  'mesh-purple-1': '#665787',
  'mesh-black': '#404041',
  'mesh-accent-dark': '#404041',
  'mesh-accent-blue': '#63A2C1',
  'mesh-accent-red': '#E54B4B'
}

export const meshTheme = deepMerge(grommet, {
  name: 'mesh',
  rounding: 8,
  spacing: 20,
  defaultMode: 'light',
  tip: {
    content: {
      background: 'dark-1',
      elevation: 'medium',
      margin: 'small',
      pad: { vertical: 'small', horizontal: 'medium' },
      round: 'small',
      size: 'xsmall'
    },
    drop: {
      align: { top: 'bottom' },
      background: 'none',
      elevation: 'none',
      margin: 'none'
    }
  },
  formField: { label: { color: 'dark-6', weight: 'bold' } },

  // icon: {
  //   size: {
  //     medium: '24px'
  //     // large: '22px'
  //   }
  // },
  global: {
    colors: {
      'light-1': '#FAFAFC',
      'light-2': '#F6F4F8',
      'light-3': '#F1EFF5',
      'light-4': '#ECEAF1',
      'light-5': '#E8E4EE',
      'light-6': '#D5CFE0',
      'dark-1': '#332B44',
      'dark-2': '#403654',
      'dark-3': '#5A4C76',
      'dark-4': '#675687',
      'dark-5': '#736198',
      'dark-6': '#8271A4',

      ...brandColors,
      brand: {
        light: 'mesh-purple-1',
        dark: 'mesh-yellow-1'
      },
      // background: {
      //   dark: '#111111',
      //   light: '#FFFFFF'
      // },
      // 'background-back': {
      //   dark: '#111111',
      //   light: '#EEEEEE'
      // },
      // 'background-front': {
      //   dark: '#222222',
      //   light: '#FFFFFF'
      // },
      'background-contrast': {
        dark: '#FFFFFF11',
        light: '#11111111'
      },
      text: {
        dark: '#EEEEEE',
        light: 'mesh-black'
      },
      'text-strong': {
        dark: '#FFFFFF',
        light: 'mesh-black'
      },
      // 'text-weak': {
      //   dark: '#CCCCCC',
      //   light: '#444444'
      // },
      // 'text-xweak': {
      //   dark: '#999999',
      //   light: '#666666'
      // },
      border: {
        dark: 'rgba(255,255,255,0.1)',
        light: 'light-5'
      },

      control: 'brand',
      'active-background': 'background-contrast',
      'active-text': 'text-strong',
      'selected-background': 'brand',
      'selected-text': 'text-strong',
      'status-critical': '#FF4040',
      'status-warning': '#FFAA15',
      'status-ok': '#00C781',
      'status-unknown': '#CCCCCC',
      'status-disabled': '#CCCCCC',
      'graph-0': 'brand',
      'graph-1': 'status-warning',
      focus: 'mesh-yellow-1'
    },
    font: {
      family: '"Lato"',
      size: '15px',
      height: '20px',
      maxWidth: '300px',
      face:
        "/* latin-ext */\n@font-face {\n  font-family: 'Lato';\n  font-style: normal;\n  font-weight: 400;\n  src: url(https://fonts.gstatic.com/s/lato/v17/S6uyw4BMUTPHjxAwXjeu.woff2) format('woff2');\n  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n}\n/* latin */\n@font-face {\n  font-family: 'Lato';\n  font-style: normal;\n  font-weight: 400;\n  src: url(https://fonts.gstatic.com/s/lato/v17/S6uyw4BMUTPHjx4wXg.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n\n/* latin */\n@font-face {\n  font-family: 'Arvo';\n  font-style: normal;\n  font-weight: 400;\n  src: url(https://fonts.gstatic.com/s/arvo/v14/tDbD2oWUg0MKqScQ7Q.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n"
    },
    active: {
      background: 'active-background',
      color: 'active-text'
    },
    hover: {
      color: { dark: 'rgba(255,255,255,0.5)', light: 'rgba(0,0,0,0.5)' },
      background: {
        color: { dark: 'rgba(0,0,0,0.5)', light: 'rgba(220,220,220,0.1)' }
      }
    },

    selected: {
      background: 'selected-background',
      color: 'selected-text'
    },
    // control: {
    //   border: {
    //     radius: '8px'
    //   }
    // },
    drop: {
      border: {
        radius: '6px'
      }
    },
    elevation: {
      light: {
        none: 'none',
        xsmall: '0px 1px 2px rgba(0, 0, 0, 0.10)',
        small: '0px 2px 6px rgba(0, 0, 0, 0.10)',
        medium: '0px 4px 14px rgba(0, 0, 0, 0.10)',
        large: '0px 8px 32px rgba(0, 0, 0, 0.10)',
        xlarge: '0px 12px 42px rgba(0, 0, 0, 0.10)'
      },
      dark: {
        none: 'none',
        xsmall: '0px 1px 2px rgba(0, 0, 0, 0.30)',
        small: '0px 2px 6px rgba(0, 0, 0, 0.30)',
        medium: '0px 4px 14px rgba(0, 0, 0, 0.30)',
        large: '0px 8px 32px rgba(0, 0, 0, 0.30)',
        xlarge: '0px 12px 42px rgba(0, 0, 0, 0.30)'
      }
    },

    size: {
      'medium-small': '288px',
      'medium-medium': '576px',
      tiny: '24px'
    },

    borderSize: {
      xsmall: '1px',
      small: '2px',
      medium: '3px',
      large: '10px',
      xlarge: '20px'
    }
  },
  layer: {
    overlay: {
      background: {
        dark: hexToRGBA(brandColors['mesh-black']),
        light: hexToRGBA(brandColors['mesh-purple-1'], 50)
      }
    }
  },
  button: {
    size: {
      small: {
        border: {
          radius: '8px'
        }
      },
      medium: {
        border: {
          radius: '8px'
        }
      },
      large: {
        border: {
          radius: '8px'
        }
      }
    },
    border: {
      radius: '8px'
    }
  },
  heading: {
    level: {
      1: {
        small: {
          size: '18px',
          height: '23px',
          maxWidth: '353px'
        },
        medium: {
          size: '20px',
          height: '25px',
          maxWidth: '407px'
        },
        large: {
          size: '26px',
          height: '31px',
          maxWidth: '513px'
        },
        xlarge: {
          size: '31px',
          height: '36px',
          maxWidth: '620px'
        }
      },
      2: {
        small: {
          size: '17px',
          height: '22px',
          maxWidth: '340px'
        },
        medium: {
          size: '19px',
          height: '24px',
          maxWidth: '380px'
        },
        large: {
          size: '21px',
          height: '26px',
          maxWidth: '420px'
        },
        xlarge: {
          size: '23px',
          height: '28px',
          maxWidth: '460px'
        }
      },
      3: {
        small: {
          size: '16px',
          height: '21px',
          maxWidth: '327px'
        },
        medium: {
          size: '18px',
          height: '23px',
          maxWidth: '353px'
        },
        large: {
          size: '19px',
          height: '24px',
          maxWidth: '380px'
        },
        xlarge: {
          size: '20px',
          height: '25px',
          maxWidth: '407px'
        }
      },
      4: {
        small: {
          size: '16px',
          height: '21px',
          maxWidth: '313px'
        },
        medium: {
          size: '16px',
          height: '21px',
          maxWidth: '327px'
        },
        large: {
          size: '17px',
          height: '22px',
          maxWidth: '340px'
        },
        xlarge: {
          size: '18px',
          height: '23px',
          maxWidth: '353px'
        }
      },
      5: {
        small: {
          size: '15px',
          height: '20px',
          maxWidth: '293px'
        },
        medium: {
          size: '15px',
          height: '20px',
          maxWidth: '293px'
        },
        large: {
          size: '15px',
          height: '20px',
          maxWidth: '293px'
        },
        xlarge: {
          size: '15px',
          height: '20px',
          maxWidth: '293px'
        }
      },
      6: {
        small: {
          size: '14px',
          height: '19px',
          maxWidth: '287px'
        },
        medium: {
          size: '14px',
          height: '19px',
          maxWidth: '287px'
        },
        large: {
          size: '14px',
          height: '19px',
          maxWidth: '287px'
        },
        xlarge: {
          size: '14px',
          height: '19px',
          maxWidth: '287px'
        }
      }
    },
    font: {
      family: '"Arvo"'
    }
  },
  paragraph: {
    small: {
      size: '15px',
      height: '20px',
      maxWidth: '293px'
    },
    medium: {
      size: '15px',
      height: '20px',
      maxWidth: '300px'
    },
    large: {
      size: '16px',
      height: '21px',
      maxWidth: '313px'
    },
    xlarge: {
      size: '16px',
      height: '21px',
      maxWidth: '327px'
    },
    xxlarge: {
      size: '18px',
      height: '23px',
      maxWidth: '353px'
    }
  },
  text: {
    xsmall: {
      size: '11px',
      height: '19px',
      maxWidth: '287px'
    },
    small: {
      size: '12px',
      height: '20px',
      maxWidth: '293px'
    },
    medium: {
      size: '14px',
      height: '20px',
      maxWidth: '300px'
    },
    large: {
      size: '16px',
      height: '21px',
      maxWidth: '313px'
    },
    xlarge: {
      size: '16px',
      height: '21px',
      maxWidth: '327px'
    },
    xxlarge: {
      size: '18px',
      height: '23px',
      maxWidth: '353px'
    }
  },
  scale: 0.2
})
export const diversionTheme = deepMerge(meshTheme, {
  name: 'diversion',
  rounding: 8,
  spacing: 20,
  defaultMode: 'light',
  global: {
    colors: {
      'light-1': '#FCFCFD',
      'light-2': '#F2F1F3',
      'light-3': '#E7E7EA',
      'light-4': '#DCDCE0',
      'light-5': '#D1D1D6',
      'light-6': '#C7C6CD',
      'dark-1': '#100F1E',
      'dark-2': '#222040',
      'dark-3': '#2D2A54',
      'dark-4': '#383469',
      'dark-5': '#433F7D',
      'dark-6': '#484487',

      ...brandColors,
      'mesh-black': '#3D4B55',
      'mesh-accent-dark': '#3D4B55',
      'mesh-purple-1': '#F4628F',
      'mesh-accent-blue': '#50B6FF',
      brand: {
        light: '#01E4BF',
        dark: '#01E4BF'
      }
    },
    font: {
      family: '"Catamaran"',
      size: '15px',
      height: '20px',
      maxWidth: '300px',
      face:
        '/* tamil */\n' +
        '@font-face {\n' +
        "  font-family: 'Catamaran';\n" +
        '  font-style: normal;\n' +
        '  font-weight: 400;\n' +
        '  font-display: swap;\n' +
        "  src: url(https://fonts.gstatic.com/s/catamaran/v15/o-0bIpQoyXQa2RxT7-5B6Ryxs2E_6n1iPHjd5bjdvXmnPy1tihg0.woff) format('woff');\n" +
        '  unicode-range: U+0964-0965, U+0B82-0BFA, U+200C-200D, U+20B9, U+25CC;\n' +
        '}\n' +
        '/* latin-ext */\n' +
        '@font-face {\n' +
        "  font-family: 'Catamaran';\n" +
        '  font-style: normal;\n' +
        '  font-weight: 400;\n' +
        '  font-display: swap;\n' +
        "  src: url(https://fonts.gstatic.com/s/catamaran/v15/o-0bIpQoyXQa2RxT7-5B6Ryxs2E_6n1iPHjd5aDdvXmnPy1tihg0.woff) format('woff');\n" +
        // eslint-disable-next-line max-len
        '  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n' +
        '}\n' +
        '/* latin */\n' +
        '@font-face {\n' +
        "  font-family: 'Catamaran';\n" +
        '  font-style: normal;\n' +
        '  font-weight: 400;\n' +
        '  font-display: swap;\n' +
        "  src: url(https://fonts.gstatic.com/s/catamaran/v15/o-0bIpQoyXQa2RxT7-5B6Ryxs2E_6n1iPHjd5a7dvXmnPy1tig.woff) format('woff');\n" +
        // eslint-disable-next-line max-len
        '  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n' +
        '}\n' +
        '/* devanagari */\n' +
        '@font-face {\n' +
        "  font-family: 'Palanquin';\n" +
        '  font-style: normal;\n' +
        '  font-weight: 500;\n' +
        '  font-display: swap;\n' +
        "  src: url(https://fonts.gstatic.com/s/palanquin/v11/9XUilJ90n1fBFg7ceXwUgnhYwpGrTC7Ozx8k.woff2) format('woff2');\n" +
        // eslint-disable-next-line max-len
        '  unicode-range: U+0900-097F, U+1CD0-1CF6, U+1CF8-1CF9, U+200C-200D, U+20A8, U+20B9, U+25CC, U+A830-A839, U+A8E0-A8FB;\n' +
        '}\n' +
        '/* latin-ext */\n' +
        '@font-face {\n' +
        "  font-family: 'Palanquin';\n" +
        '  font-style: normal;\n' +
        '  font-weight: 500;\n' +
        '  font-display: swap;\n' +
        "  src: url(https://fonts.gstatic.com/s/palanquin/v11/9XUilJ90n1fBFg7ceXwUgnhYzZGrTC7Ozx8k.woff2) format('woff2');\n" +
        // eslint-disable-next-line max-len
        '  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n' +
        '}\n' +
        '/* latin */\n' +
        '@font-face {\n' +
        "  font-family: 'Palanquin';\n" +
        '  font-style: normal;\n' +
        '  font-weight: 500;\n' +
        '  font-display: swap;\n' +
        "  src: url(https://fonts.gstatic.com/s/palanquin/v11/9XUilJ90n1fBFg7ceXwUgnhYw5GrTC7Ozw.woff2) format('woff2');\n" +
        // eslint-disable-next-line max-len
        '  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n' +
        '}'
    }
  },
  heading: {
    font: {
      family: '"Palanquin"'
    }
  }
})
export const nivoTheme = {
  textColor: meshTheme.global.colors['dark-6'],
  // fontSize: 14,
  axis: {
    domain: {
      line: {
        stroke: meshTheme.global.colors['light-3'],
        strokeWidth: 0
      }
    },
    ticks: {
      line: {
        stroke: meshTheme.global.colors['light-6'],
        strokeWidth: 2
      }
    }
  },
  grid: {
    line: {
      stroke: meshTheme.global.colors['light-3'],
      strokeWidth: 1
    }
  }
}

export const departmentColors = {
  bakery: '#FFBE42',
  deli: '#F59148',
  dairy: '#12B3B2',
  'meat/seafood': '#D54C5B',
  grocery: '#D67597',
  produce: '#AFD24A',
  other: '#13767D',
  otherDark: meshTheme.global.colors['light-6']
}
export const destinationColors = {
  charity: '#12B3B2',
  farm: '#FFBE42',
  compost: '#13767D'
}
export const graphColors = {
  // dairy, meat, grocery, deli, bakery, produce, other
  // fruity colour order is set based on Analgous colors.
  // Analogous colors are adjacent to or near each other on the color wheel. Together,
  // they look aesthetically pleasing and produce a calming effect, as opposed to the intensity of complementary colors.
  fruity: ['#12B3B2', '#D54C5B', '#D67597', '#F59148', '#FFBE42', '#AFD24A', '#88C46B'],
  meshBasic: [
    brandColors['mesh-accent-dark'],
    brandColors['mesh-accent-blue'],
    brandColors['mesh-accent-red']
  ]
}
